import React from 'react'
import { NavigationButton } from '../../../Shared'
import '../../../../assets/scss/components/OnboardingHomepage/completeMsgHome/complete-message-home.css'

import GoodJob from '../../../../assets/img/Tipps_GoodJob.PNG'
/*
    This component is the congratulation messsage at the end of teacher's onboarding homepage
*/

const CompleteMsgHome = ()=>{
    return (
        <div className='completeMsgHome'>
            <div className='completeMsgHome-congratulation'>
                <img src={GoodJob} alt="good job image"/>
                <h2>CONGRATULATIONS!</h2>
                <p>You have successfully taken the first step towards teaching with Tyto Online.</p>
            </div>
            <div className="completeMsgHome-joinCommunity">
                <p>Want to learn more about how to implement Tyto Online, <br /> with a community for NGSS + digital learning?</p>
                <NavigationButton message='Join the Community' url="https://community.tytoonline.com/" styleType='blue' actionType='link' isExternal={true} />
            </div>
        </div>
    )
}
export default CompleteMsgHome
